import Konva from "konva";
import _, { cloneDeep } from "lodash";
import { isEmptySeats } from "../utilsEdit";
import { TextParams, SEAT } from "../Constants";
import { AppStage } from "@/core/AppStage";
import { mainGroups } from "@/core/MainGroups";
import { seatsGroups } from "@/core/SeatsGroup";
import { deselectGroup, ActionButtonsGroup, setId } from "../utils";
import { createSeat, emptySeat,  deleteSeat, updateSeat } from "../seatUtils";


import {
  bindRowsAndSeats,
  generateRowGroup,
  drawSeatGroupBorder,
  flipObject,
  mergeArrays,
  fixSectionPosition,
} from "./_utils";

import { updateSectionLayout } from "../builderSetup";
import { usedIds } from "@/core/UsedIds";
import { findRemovedSectionNumber } from "../utilsEdit";

const seatSize = SEAT.size;
let seatRadius = 20;
let borderLayer = {};
let rowLabelGroups = {};
let builder;
let cloneSections = {};
let curveDelay = {};
let skewDelay = {};
let resetShift = false;

export const generateSection = (
  seatsBind,
  configs,
  component,
  position,
  groupId
) => {
  const appStage = new AppStage();
  builder = component;
  const {
    name,
    rows,
    seatSpacing,
    rowSpacing,
    seatDirection,
    rowDirection,
    curveValue,
    skewValue,
    rotation,
    seats,
    alignment,
    // rowSortType,
    hideTitle  } = configs;
  let rowDir;
  let seatDir;
  if (groupId) {
    rowDir = rowDirection;
    seatDir = seatDirection;
  }
  
  let deletedSeats = [];
  const draggable = configs.draggable !== undefined ? configs.draggable : true;

  let mainGroup = new Konva.Group({
    name,
    draggable: draggable,
    rotation: 0,
    type: "section",
    category: 'seats',
    seatsBind,
    configs
  });

  let seatsCount = 0;
  mainGroup.seatsBind = seatsBind;
  if (groupId) {
    mainGroup.setAttrs({
      id: groupId,
      rowDir,
      seatDir,
    });

    if (rowDir) {
      mainGroup.rowDir = rowDir;
      mainGroup.seatDir = seatDir;
    }
  } else {
    mainGroup.setAttrs({
      id: setId(),
      rowDir: "91",
      seatDir: "19",
    });

    mainGroup.rowDir = "91";
    mainGroup.seatDir = "19";
  }
 
  const id = mainGroup.attrs.id;
 
  let seatsGroup = new Konva.Group({
    group: "seatGroup",
    type: "seatGroup",
  });

  let rowLabelGroup = new Konva.Group({ isRow: true, type: "left" });

  rowLabelGroup.isRow = true;
  let rowLabelX = 0;
  let rowLabelY = (seatRadius * 2 * rows) / 2 - 10; // position row label in the center of the section
  const sectionWidth = (seatSize + 5 + 2 * seatSpacing) * seats - 2 * seatSpacing - 5;
  const sectionHeight = (seatSize + 5 + 2 * rowSpacing) * rows - 2 * rowSpacing - 5;
  
  
  for (let index = 0; index < seatsBind.length; index++) {
    const eachRowSeats = seatsBind[index].seats;

    if(groupId) usedIds.add(seatsBind[index].id)
      
    let leftEmpty = 0;
    let rightEmpty = 0;

    if (
      eachRowSeats[0].number &&
      eachRowSeats[eachRowSeats.length - 1].number
    ) {
    } else {
      for (let j = 0; j < eachRowSeats.length; j++) {
        const seat = eachRowSeats[j];
        if (seat.number) {
          break;
        } else if (!seat.number) {
          leftEmpty++;
        }
      }

      for (let j = eachRowSeats.length - 1; j >= 0; j--) {
        const seat = eachRowSeats[j];
        if (seat.number) {
          break;
        } else if (!seat.number) {
          rightEmpty++;
        }
      }
    }

    if(resetShift) {
      seatsBind[index].shift = 0;
    } 
    seatsBind[index].leftEmpty = leftEmpty;
    seatsBind[index].rightEmpty = rightEmpty;

    const centerShift = (leftEmpty != 0 || rightEmpty != 0) && alignment === 'center' ? (rightEmpty - leftEmpty) / 2 * (seatSize + 5 + 2 * seatSpacing) : 0;
    const shift = seatsBind[index].shift ? seatsBind[index].shift : 0;
    const key = seatsBind[index].oldKey ? '' : seatsBind[index].editedKey || seatsBind[index].editedKey === '' ? seatsBind[index].editedKey : seatsBind[index].key;
    const RowUid = seatsBind[index].id;
    const seatY = (seatSize + 5 + rowSpacing * 2) * index ;
    const rowLabelOptions = generateRowGroup(
      index,
      key,
      rowLabelX,
      rowLabelY,
      seatRadius,
      rowSpacing,
      seatSpacing
    );

    let rowLabel = new Konva.Text({ ...rowLabelOptions, id: RowUid });
    rowLabel.id = RowUid;
    rowLabelGroup.setAttrs({ 
      rowId: RowUid,

    });

    rowLabelGroup.add(rowLabel);
    const rowLabelWidth = 44;
    // const labelCustomShift = alignment === 'center' ? centerShift : shift;

    rowLabel.setAttrs({
      offsetX: rowLabelWidth / 2,
      offsetY: seatSize / 2,
      width: rowLabelWidth,
      height: seatSize,
      verticalAlign: 'middle',
      align: 'center',
      y: seatY + seatSize / 2,
      type: 'label',
      groupId: id,
      emptyShift: [leftEmpty, rightEmpty],
      customShift: shift,
      centerShift: centerShift
    })
    
    for (let i = 0; i < seatsBind[index].seats.length; i++) {
      const seatItems = seatsBind[index].seats[i];
      if(groupId) {
        usedIds.add(seatItems.id)
      } 
      
      let seatWithNumGroup = new Konva.Group({
        id: seatItems.id,
        rowId: RowUid,
        row: rowLabel.attrs.text,
        number: seatItems.number,
        invalid: seatItems.invalid,
        deleted: !(seatItems.number || seatItems.number === 0)
      });

      const curveSize = seatsBind[0].seats[i].curveSize ? seatsBind[0].seats[i].curveSize : 0; 
      const skewSize = seatsBind[0].seats[i].skewSize ? seatsBind[0].seats[i].skewSize : 0;

      const gapY = Math.abs(curveValue * seats / 5) > Math.abs(skewValue * seats / 5) ? Math.abs(curveValue * seats / 5) : Math.abs(skewValue * seats / 5)
   
      const seatX = (seatSize + 5 + seatSpacing * 2) * i + shift + centerShift;
      
      const listening = seatX >= -(seatSize + 5) && seatX <=  sectionWidth;
      const offsetX = listening ? 0 : seatX  < 0 ? sectionWidth / 2 : - sectionWidth / 2;
      const { seat, seatNumber } = createSeat(0, 0, seatItems.number, seatItems.invalid, seatWithNumGroup)

      seatWithNumGroup.rowId = RowUid;
      seatWithNumGroup.row = rowLabel.attrs.text;
      seatWithNumGroup.number = seatItems.number;
      seatWithNumGroup.invalid = seatItems.invalid;
      seatWithNumGroup.setAttrs({
        x: seatX,
        y: seatY,
        pos: [index, i],
        listening: listening,
        groupId: id,
        // offsetX: -offsetX,
      })

      if(!listening) {
        seatWithNumGroup.children[0].setAttrs({
          width: 0,
          height: 0
     
        })
      }

      if(index == 0) {
        seatWithNumGroup.setAttrs({
          curveSize: curveSize,
          skewSize: skewSize
        })
      }

      if(i == 0) {
        seatWithNumGroup.setAttrs({
          leftEmpty: leftEmpty
        })
      } else if (i == seatsBind[index].seats.length - 1) {
        seatWithNumGroup.setAttrs({
          rightEmpty: rightEmpty
        })
      }

      if (!seatItems.number && seatItems.number !== 0) {
        emptySeat(seat, seatNumber, seatWithNumGroup, i, alignment);
      

        if(!deletedSeats.includes(seatsBind[index])) {
          deletedSeats.push(seatsBind[index])
        }
      } else {
        seatsCount++;
      }
      
      seatsGroup.add(seatWithNumGroup);
    }

  }

  component.countTickets(id, seatsCount, 'seats');
  
  seatsGroups.add(seatsGroup, id);
  rowLabelGroups[id] = rowLabelGroup.y();
  rowLabelGroup.type = "left";
  mainGroups.add(mainGroup, id);
  const currentGroup = mainGroups.get(id);
  const currentSeats = seatsGroups.get(id);
  mainGroup.add(currentSeats, rowLabelGroup); //

  const seatsGroupBound =currentSeats.getClientRect();
  
  const seatGroupOffset = {
    offsetX: sectionWidth / 2,
    offsetY: seatsGroupBound.height / 2,
  };

  currentSeats.setAttrs({
    ...seatGroupOffset,
  });

  const cloneRowRight = rowLabelGroup.clone();

  cloneRowRight.setAttrs({
    type: "right",
    isRow: true,
  });

  

  cloneRowRight.type = "right";
  cloneRowRight.isRow = true;

  mainGroup.add(cloneRowRight);


  rowLabelGroup.setAttrs({
    x: -sectionWidth / 2 - 22,
    y: -sectionHeight / 2
  });

  cloneRowRight.setAttrs({
    x: sectionWidth / 2 + 22,
    y: -sectionHeight / 2
  });

  cloneRowRight.children.forEach(rightLabel => {
    rightLabel.setAttrs({
      offsetX: rightLabel.attrs.width / 2 + rightLabel.attrs.emptyShift[1] * (seatSize + 5) + (rightLabel.attrs.emptyShift[1] - 1) * seatSpacing * 2
    })
  })

  const { layerBorder } = drawSeatGroupBorder(
    seatsGroupBound,
    currentGroup,
    seats,
    seatSpacing
  );

  borderLayer[id] = layerBorder;

  mainGroup.add(borderLayer[id]);

  borderLayer[id].moveToTop()
 
  let tableName = new Konva.Text({
    text: name,
    fontSize: TextParams.SIZE_XL,
    fontFamily: "Lato-Regular",
    fill: "white",
    align: TextParams.ALIGN_CENTER,
    verticalAlign: "middle",
    type: "name",
  });

  mainGroup.add(tableName);

  if (hideTitle === true) tableName.visible(false);

  tableName.setAttrs({
    offsetX: tableName.width() / 2,
    offsetY: tableName.height() / 2,
    y: 0 - sectionHeight / 2 - 20,
  });

  if (position) {
    mainGroup.position(position);
  } else {
    const scale = appStage.scale();
    const mainGroupPos = mainGroup.getClientRect();

    mainGroup.position({
      x: (((-appStage.x() + appStage.width() / 2) / scale.x)),
      y: ((-appStage.y() / scale.y + (mainGroupPos.height / 2))) + 20,
    });
  }

  if (!configs.label_left) {
    rowLabelGroup.visible(false);
  }

  if (!configs.label_right) {
    cloneRowRight.visible(false);
  }

  borderLayer[id].setAttrs({
    width: sectionWidth + 10,
    height: sectionHeight + 10,
    offsetX: sectionWidth / 2 ,
    offsetY: sectionHeight / 2 ,
    x: -5,
    y: -5
  });

  // fixSectionPosition(currentGroup, currentSeats, rowLabelGroup, cloneRowRight);
  // if(deletedSeats.length > 0) {
  //   checkDeletedSeats(deletedSeats);
  // }
  if ("curveValue" in configs && curveValue !== null && curveValue != 0) {
    // mainGroup.visible(false);
    curveSection(curveValue, id, configs);
  }
   
  if ("skewValue" in configs && skewValue !== null && skewValue != 0) {
    // mainGroup.visible(false);
    skewSection(skewValue, id, configs);
  }
   
  if ("rotation" in configs && rotation !== null)
    rotateSection(rotation, id, configs);
  resetShift = false;
  if(appStage.editing && currentGroup.attrs.draggable) {
    currentGroup.setAttrs({ 
      draggable: false,
      editDrag: true
    });
  }



  return { mainGroup };
};

const getRemoveds = (seatsBind) => {
  let leftEmpty = 0;
  let rightEmpty = 0;
  const eachRowSeats = seatsBind.seats;

  if (
    eachRowSeats[0].number &&
    eachRowSeats[eachRowSeats.length - 1].number
  ) {

  } else {
    for (let j = 0; j < eachRowSeats.length; j++) {
      const seat = eachRowSeats[j];
      if (seat.number) {
        break;
      } else if (!seat.number) {
        leftEmpty++;
        if(leftEmpty > 1) {
          eachRowSeats[j-1].setAttrs({
            extra: true
          });
        }
      }
    }

    for (let j = eachRowSeats.length - 1; j >= 0; j--) {
      const seat = eachRowSeats[j];
      if (seat.number) {
        break;
      } else if (!seat.number) {
        rightEmpty++;
        if(rightEmpty > 1) {
          eachRowSeats[j+1].setAttrs({
            extra: true
          });
        }
      }
    }
  }

  return { leftEmpty, rightEmpty }
}




const normalizeSeatStartsWithBySortType = (seatSortType, rawStartsWith) => {
  // For ABC: we expect "A" or "ZZ"-like (only letters).
  if (seatSortType === "ABC") {
    const startsStr = String(rawStartsWith ?? "");
    // If override was created in numeric mode, it may contain digits (e.g. "9"),
    // and charCodeAt(0) would turn "9" -> ':' sequence. In this case, caller must skip applying override.
    if (!/^[A-Z]+$/.test(startsStr)) return null;
    return startsStr;
  }

  const startsNum = Number(rawStartsWith);
  if (!Number.isFinite(startsNum)) return null;

  // Keep parity restriction consistent with `bindRowsAndSeats` for seatSortType.
  let normalizedStartsWith = startsNum;
  if (seatSortType === "135") {
    if (normalizedStartsWith === 0) normalizedStartsWith = 1;
    if (normalizedStartsWith % 2 === 0) normalizedStartsWith = normalizedStartsWith - 1;
  }

  if (seatSortType === "246") {
    if (normalizedStartsWith % 2 !== 0) normalizedStartsWith = normalizedStartsWith + 1;
  }

  return String(normalizedStartsWith);
};

const applyRowSeatStartsWithOverrides = (layerId, configs) => {
  const currentGroup = mainGroups.get(layerId);
  const currentSeats = seatsGroups.get(layerId);
  if (!currentGroup || !currentSeats) return;

  const seatsBind = currentGroup.seatsBind || [];
  const rowOverrides = new Map();

  seatsBind.forEach((row) => {
    if (
      row.rowSeatStartsWith !== undefined &&
      row.rowSeatStartsWith !== null &&
      row.rowSeatStartsWith !== ""
    ) {
      rowOverrides.set(row.id, row.rowSeatStartsWith);
    }
  });

  if (rowOverrides.size === 0) return;

  const { seatSortType } = configs;

  currentSeats.children.forEach((seatNode) => {
    const overrideVal = rowOverrides.get(seatNode.rowId);
    if (overrideVal === undefined) return;

    // Renumber only seats that currently have an assigned number.
    if (seatNode.number === null || seatNode.number === undefined) return;

    const normalizedOverride = normalizeSeatStartsWithBySortType(
      seatSortType,
      overrideVal
    );

    let seatStartsWithForCalc = normalizedOverride;
    if (seatStartsWithForCalc === null) {
      // If per-row override был введен в numeric-режиме, а сейчас переключились на ABC,
      // мы должны все равно переписать ряд по текущему section-level startWith,
      // иначе `mergeArrays` протянет старые `editedNumber` и ряд "не перепишется".
      if (seatSortType === "ABC") {
        seatStartsWithForCalc = normalizeSeatStartsWithBySortType(
          seatSortType,
          configs.seatStartsWith
        );
      }
    }

    if (seatStartsWithForCalc === null) return;

    const recoverNumber = findRemovedSectionNumber(seatNode, seatsBind, {
      ...configs,
      seatStartsWith: seatStartsWithForCalc,
    });

    seatNode.number = recoverNumber;
    seatNode.setAttrs({
      number: recoverNumber,
      rowSeatStartsWith: String(seatStartsWithForCalc),
    });

    const textNode = seatNode.children[1];
    if (seatNode.invalid) {
      textNode.text("");
      textNode.setAttrs({
        text: "",
        fontFamily: "icon",
        fontSize: 24,
      });
    } else {
      textNode.text(recoverNumber);
      textNode.setAttrs({
        text: recoverNumber,
        fontFamily: "Lato-Regular",
        fontSize: 14,
      });
    }

    // Sync model inside seatsBind too.
    const rowBind = seatsBind.find((r) => r.id === seatNode.rowId);
    if (rowBind) {
      const seatItem = rowBind.seats.find((s) => s.id === seatNode.getId());
      if (seatItem) {
        seatItem.number = recoverNumber;
        seatItem.editedNumber = recoverNumber;
      }
    }
  });
};

export const updateSection = (id, configs, alignment) => {
  let currentGroup = mainGroups.get(id);
  const appStage = new AppStage();
  const mainLayer = appStage.children[0];
  const position = currentGroup.position();
  const { rowSeatData } = bindRowsAndSeats(configs);
  const { seatsBind } = currentGroup;
  const mergedArr = mergeArrays(seatsBind, rowSeatData, configs.rowDirection, configs.seatDirection);
  const isEmpty = isEmptySeats.section(mergedArr);

  if (isEmpty) {
    return false;
  }

  if(alignment) {
    resetShift = true;
  }

  currentGroup.destroy();
  mainGroups.remove(id);

  const { mainGroup } = generateSection(
    mergedArr,
    configs,
    builder,
    position,
    id
  );

  mainLayer.add(mainGroup);
  mainGroups.add(mainGroup, id);
  currentGroup = mainGroups.get(id);
  borderLayer[id].moveToBottom();
  currentGroup.setAttrs({ configs });

  applyRowSeatStartsWithOverrides(id, configs);
};

export const cancelChanges = (configs) => {
  const { layerId } = configs;
  const cloneData = cloneSections[layerId];
  const appStage = new AppStage();
  const mainLayer = appStage.children[0];
  const currentGroup = mainGroups.get(layerId);
  const position = currentGroup.position();

  currentGroup.destroy();

  const { mainGroup } = generateSection(
    cloneData,
    configs,
    builder,
    position,
    layerId
  );

  mainLayer.add(mainGroup);
  
  deselectGroup();
};

export const deleteSectionSeat = (payload) => {
  const { layerId, rowId } = payload.seatData; // configs,
  const appStage = new AppStage();
  const mainLayer = appStage.children[0];
  const currentGroup = mainGroups.get(layerId);
  const { seatsBind } = currentGroup;
  const position = currentGroup.position();
  const { configs } = currentGroup.attrs;
  const changedSeatsBind = deleteSeat(seatsBind, payload);

  currentGroup.destroy();

  const { mainGroup } = generateSection(
    changedSeatsBind,
    configs,
    builder,
    position,
    layerId
  );

  mainLayer.add(mainGroup);
  borderLayer[layerId].moveToBottom();
  applyRowSeatStartsWithOverrides(layerId, configs);
};

export const editSectionSeat = (payload, type) => {
  const { layerId } = payload.seatData;
  const currentGroup = mainGroups.get(layerId);
  const seatsBind = currentGroup.seatsBind;
  updateSeat(seatsBind, payload, type);
};

export const repositionLabelX = (label, seatSpacing, rotation, edge) => {
 const labelWidth = +label.attrs.width;
 const labelType = label.parent.type;
 let labelOffsetX, labelOffsetY;
 const labelShift = (label.attrs.customShift + label.attrs.centerShift) / (seatSize + 5 +2 * seatSpacing);
 if(!edge) {
    labelOffsetX = labelWidth / 2;
    labelOffsetY = seatSize / 2;
 } else {
    if(labelType === 'left') {
        const leftEmptySeats = +label.attrs.emptyShift[0];
        labelOffsetX = labelWidth / 2 - ((leftEmptySeats + labelShift) *  (seatSize + 5 +  seatSpacing * 2) ) * Math.cos(rotation * Math.PI / 180);
        labelOffsetY = seatSize / 2 - ((leftEmptySeats + labelShift) *  (seatSize + 5 +  seatSpacing * 2)  ) * Math.sin(rotation * Math.PI / 180);
    } else if (labelType === 'right') {
        const rightEmptySeats = +label.attrs.emptyShift[1];
        labelOffsetX = labelWidth / 2 + ((rightEmptySeats - labelShift) *  (seatSize + 5 +  seatSpacing * 2) ) * Math.cos(rotation * Math.PI / 180);
        labelOffsetY = seatSize / 2 + ((rightEmptySeats - labelShift) *  (seatSize + 5 +  seatSpacing * 2) ) * Math.sin(rotation * Math.PI / 180);
    }
 }
 

  label.setAttrs({
    offsetX: labelOffsetX,
    offsetY: labelOffsetY
  });
}
const repositionLabelY = (left, right, seats, row, curve, skew, rowSpacing, seatspacing, gapY, edge) => {

  if(left) {

    const leftLabel = left.children[row];
    const leftEmptySeats = leftLabel.attrs.emptyShift[0];
    const leftShift = (leftLabel.attrs.customShift + leftLabel.attrs.centerShift ) / (seatSize + 5 + 2 * seatspacing) 

    const labelSkew = !edge ? 0 : skew * 3 * (leftEmptySeats + leftShift);
    const curveCoeff = !edge ? (seats - 0.5) / 2 : (seats - 0.5 ) / 2  - leftEmptySeats  - leftShift ;
    const labelCurve = Math.round((curve * curveCoeff * curveCoeff * 1.2) / Math.PI);
    const leftTopY = row * (SEAT.size + 5 + 2 * rowSpacing + gapY) + SEAT.size / 2  + labelCurve + labelSkew;
    leftLabel.setAttrs({
      y: leftTopY
    });
    left.moveToTop()
  };

  if(right) {
    const rightLabel = right.children[row];
    const rightEmptySeats = rightLabel.attrs.emptyShift[1];
    const rightShift = !edge ? 0 : (rightLabel.attrs.customShift + rightLabel.attrs.centerShift ) / (SEAT.size + 5 + 2 * seatspacing );
    const labelSkew = !edge ? skew * 3 * (seats - 1) : skew * 3 * (seats - 1 - rightEmptySeats + rightShift);
    const curveCoeff = !edge ? (seats - 0.5) / 2 : (seats - 0.5) / 2 - rightEmptySeats + rightShift;
    const labelCurve = Math.round((curve * curveCoeff * curveCoeff * 1.2) / Math.PI);
    const rightTopY = row * (SEAT.size + 5 + 2 * rowSpacing + gapY) + SEAT.size / 2  + labelCurve + labelSkew;
    rightLabel.setAttrs({
      y: rightTopY
    });
    right.moveToTop()
  }
}

export const curveSection = (curveValue, id) => {
  let sectionTop = Infinity;
  let sectionBottom = -Infinity;
  const currentGroup = mainGroups.get(id); 
  const currentSeats = seatsGroups.get(id);
  const allSeats = currentSeats.children;
  const { configs } = currentGroup.attrs;
  const { seats, seatSpacing, rowSpacing, skewValue, edgeLabels } = configs;
  const seatWidtharea = (seatSize + 5 + seatSpacing * 2);
  const seatHeightArea = (seats * (seatSize + 5 + rowSpacing * 2) - rowSpacing * 2) / seats;
  const gapY = Math.abs(curveValue * seats / 5) > Math.abs(skewValue * seats / 5) ? Math.abs(curveValue * seats / 5) : Math.abs(skewValue * seats / 5)
  
  const center = seats * (seatWidtharea) / 2 ;
 
  if(curveDelay[id]) {
    clearTimeout(curveDelay[id]);
    curveDelay[id] = null;
  }
  
  curveDelay[id] = setTimeout(() => {
    
    const leftLabels = currentGroup.children.find((g) => g.attrs.type === "left");
    const rightLabels = currentGroup.children.find((g) => g.attrs.type === "right");
    
    allSeats.forEach((item, index) => {
      const itemX = item.x();
      const row = Math.floor(index / seats)
     
      const itemDefY = (seatHeightArea + gapY) * row; 
      
      let coeff = (Math.abs(itemX + 20 - center) / seatWidtharea)

      let curveSize = Math.round((curveValue * coeff * coeff * 1.2) / Math.PI) ;
      let skewSize = item.attrs.skewSize ? item.attrs.skewSize : 0;

      item.setAttrs({
        y: curveSize + itemDefY + skewSize,
      });

      item.setAttrs({
        curveSize: curveSize
      });

      repositionLabelY(leftLabels, rightLabels, seats, row, curveValue, skewValue, rowSpacing, seatSpacing, gapY, edgeLabels);

      let currentTop = item.attrs.number ? item.attrs.y : null;
      let currentBottom = item.attrs.number ? item.attrs.y : null;

      sectionTop = currentTop === null || sectionTop < currentTop ? sectionTop : currentTop;
      sectionBottom = currentBottom === null || sectionBottom > currentBottom ? sectionBottom : currentBottom

    })
   
    const confs = currentGroup.attrs.configs;
    currentGroup.setAttrs({ configs: { ...confs, curveValue } });
    fixSectionPosition(currentGroup, currentSeats, leftLabels, rightLabels, sectionTop, sectionBottom);
  }, 0)
};

export const skewSection = (skewX, id, configs) => {
  let sectionTop = Infinity;
  let sectionBottom = -Infinity;
  const currentGroup = mainGroups.get(id); 
  const currentSeats = seatsGroups.get(id);
  const allSeats = currentSeats.children;
  const { seats, seatSpacing, rowSpacing, curveValue, edgeLabels } = configs;
  const seatWidtharea = (seatSize + 5 + seatSpacing * 2);
  const gapY = Math.abs(curveValue * seats / 5) > Math.abs(skewX * seats / 5) ? Math.abs(curveValue * seats / 5) : Math.abs(skewX * seats / 5)
  const seatHeightArea = (seats * (seatSize + 5 + rowSpacing * 2 + gapY) - rowSpacing * 2) / seats;

  if(skewDelay[id]) {
    clearTimeout(skewDelay[id]);
    skewDelay[id] = null;
  }
  
  skewDelay[id] = setTimeout(() => {
    
    const leftLabels = currentGroup.children.find((g) => g.attrs.type === "left");
    const rightLabels = currentGroup.children.find((g) => g.attrs.type === "right");
    
   
    allSeats.forEach((item, index) => {
      
      const itemX = item.x() / seatWidtharea * 3;
      const row = Math.floor(index / seats);
      const idx = index - row * seats;
     
      const itemDefY = (seatHeightArea) * Math.floor(index / seats) ;  
      let skewSize = Math.round(skewX * itemX)  ;
      let curveSize = item.attrs.curveSize ? item.attrs.curveSize : 0;
  
      item.setAttrs({
        y: skewSize + itemDefY + curveSize,
      });
  
      item.setAttrs({
        skewSize: skewSize 
      }); 

      repositionLabelY(leftLabels, rightLabels, seats, row, curveValue, skewX, rowSpacing, seatSpacing, gapY, edgeLabels);

      let currentTop = item.attrs.number ? item.attrs.y : null;
      let currentBottom = item.attrs.number ? item.attrs.y : null;

      sectionTop = currentTop === null || sectionTop < currentTop ? sectionTop : currentTop;
      sectionBottom = currentBottom === null || sectionBottom > currentBottom ? sectionBottom : currentBottom
     
    })
    
    const confs = currentGroup.attrs.configs;

    currentGroup.setAttrs({ configs: { ...confs, skewValue: skewX } });
    fixSectionPosition(currentGroup, currentSeats, leftLabels, rightLabels, sectionTop, sectionBottom);
  }, 0)
};

export const rotateSection = (rotation, id, configs) => {
  const currentGroup = mainGroups.get(id);
  const currentSeats = seatsGroups.get(id);
  currentGroup.rotation(rotation);
  let oppositeRotation = -rotation;
  const { seatSpacing, edgeLabels } = currentGroup.attrs.configs;
  let seats = currentSeats.getChildren();
  let groups = currentGroup.getChildren();
  const sectionName = groups.find((g) => g.attrs.type === "name");

  if (rotation > 90) sectionName.rotation(180);
  if (rotation < 90) sectionName.rotation(0);
  if (rotation < -90) sectionName.rotation(-180);

  groups.find((child) => {
    if (child.isRow) {
      for (let i = 0; i < child.children.length; i++) {
        const element = child.children[i];
        element.rotation(oppositeRotation);
        repositionLabelX(element, seatSpacing, rotation, edgeLabels);
      }
    }
  });

  for (let i = 0; i < seats.length; i++) {
    const element = seats[i].children[1];
    if(element) {
      element.rotation(oppositeRotation);
    }

  }

  configs = { ...configs, rotation };
  currentGroup.setAttrs({ configs });
};

export const showHideLabels = ({ label_left, label_right, layerId }) => {
  const currentGroup = mainGroups.get(layerId);

  currentGroup.find((node) => {
    if (node.isRow) {
      if (node.type === "right") {
        if (label_right) node.visible(true);
        else node.visible(false);
      } else if (node.type === "left") {
        if (label_left) node.visible(true);
        else node.visible(false);
      }
    }
  });

  const confs = currentGroup.attrs.configs;

  currentGroup.setAttrs({ configs: { ...confs, label_left, label_right } });
};

export const repositionLabels = ({edgeLabels, layerId}) => {
  const currentGroup = mainGroups.get(layerId);
  let groups = currentGroup.getChildren();
  const confs = currentGroup.attrs.configs;
  const { seats, seatSpacing, rotation, curveValue, skewValue, rowSpacing } = confs;
  const gapY = Math.abs(curveValue * seats / 5) > Math.abs(skewValue * seats / 5) ? Math.abs(curveValue * seats / 5) : Math.abs(skewValue * seats / 5);
  groups.find((child) => {
    if (child.isRow) {
      const leftLabels = groups.find((g) => g.attrs.type === "left");
      const rightLabels = groups.find((g) => g.attrs.type === "right");
      for (let i = 0; i < child.children.length; i++) {
        const element = child.children[i];
        repositionLabelX(element, seatSpacing, rotation, edgeLabels);
        repositionLabelY(leftLabels, rightLabels, seats, i, curveValue, skewValue, rowSpacing, seatSpacing, gapY, edgeLabels);
      }
    }
  });

  currentGroup.setAttrs({ configs: { ...confs, edgeLabels } });
}

export const showHideTitle = ({ hideTitle, layerId }) => {
  const currentGroup = mainGroups.get(layerId);
  const confs = currentGroup.attrs.configs
  const text = currentGroup.children.find(g => g.attrs.type === "name")

  if (text) text.visible(!hideTitle)

  currentGroup.setAttrs({ configs: { ...confs, hideTitle } });

}

export const sectionActions = {
  editAction: (id, component, configs, stage) => {
    const currentGroup = mainGroups.get(id);
    const currentSeats = seatsGroups.get(id);
    currentSeats.moveToTop();
    cloneSections[id] = _.cloneDeep(currentGroup.seatsBind);
    AppStage.addKey('editing', id);

    const conf = currentGroup.attrs.configs;

    component.editSection(id, conf, currentGroup);

    borderLayer[id].setAttrs({stroke: ''});
  },
  copyAction: (id, component, configs) => {
    const currentGroup = mainGroups.get(id);
    const appStage = new AppStage();
    const mainLayer = appStage.children[0];
    const { seatsBind } = currentGroup;
    const newSeatsBind = cloneDeep(seatsBind);

    for(let i = 0; i < seatsBind.length; i++) {
      newSeatsBind[i].id = setId();
      for(let j = 0; j < newSeatsBind[i].seats.length; j++) {
        newSeatsBind[i].seats[j].id = setId()
      }
      
    }

    const conf = currentGroup.attrs.configs;
    const updatedConf = {...conf, draggable: true};
    const { mainGroup } = generateSection(newSeatsBind, updatedConf, component);
    mainLayer.add(mainGroup);
    deselectGroup();
    borderLayer[id].setAttrs({stroke: ''});
  },
  sortAction: (id, component) => {
    const appStage = new AppStage();
    const currentGroup = mainGroups.get(id);
    const { configs } = currentGroup.attrs;
    currentGroup.seatDir = currentGroup.seatDir === "19" ? "91" : "19";
    configs.seatDirection = currentGroup.seatDir;
    const position = currentGroup.position();
    const flipedSeats = flipObject(
      currentGroup.seatsBind,
      configs.seatDirection
    );

    const newConfigs = { ...configs, skewValue: -configs.skewValue, rotation: -configs.rotation };

    const { mainGroup } = generateSection(
      flipedSeats,
      newConfigs,
      builder,
      position,
      id
    );

    updateSectionLayout(id, mainGroup);
    currentGroup.setAttrs({ newConfigs });
    AppStage.resetSelected();
    const actionsButtons = new ActionButtonsGroup();
    actionsButtons.hideActions();
    appStage.container().style.cursor = "default";
    borderLayer[id].setAttrs({stroke: ''});
  },

}

export const copySectionElementAtPosition = (id, component, position) => {
  const currentGroup = mainGroups.get(id);
  const appStage = new AppStage();
  const mainLayer = appStage.children[0];
  const { seatsBind } = currentGroup;
  const newSeatsBind = cloneDeep(seatsBind);

  for (let i = 0; i < seatsBind.length; i++) {
    newSeatsBind[i].id = setId();
    for (let j = 0; j < newSeatsBind[i].seats.length; j++) {
      newSeatsBind[i].seats[j].id = setId();
    }
  }

  const conf = currentGroup.attrs.configs;
  const updatedConf = { ...conf, draggable: true };
  const { mainGroup } = generateSection(newSeatsBind, updatedConf, component, position);
  mainLayer.add(mainGroup);
  return mainGroup.attrs.id;
};

export const saveChanges = (id) => {
  borderLayer[id].visible(true);
}